<template>
  <div>
    <button :disabled="disabled" :class="classes" :type="type">
      <slot></slot>
    </button>
  </div>
</template>

<script>
import { propValidationService } from '../functions';

const THEMES_TYPES = [
  { key: 'normal' },
  { key: 'light' },
];

export default {
  name: 'dx-button',
  props: {
    theme: {
      default: 'normal',
      type: String,
      validator: propValidationService.buildValidator({
        validValues: THEMES_TYPES.map((theme) => theme.key),
        errorMessage: 'You should inform a valid theme',
      }),
    },
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        [`theme--${this.theme}`]: this.theme !== 'normal' ? this.theme : false,
      };
    },
  },
};
</script>

<style scoped lang="scss">
  div {
    padding: var(--dx-space-size--xs);

    button {
      background: var(--dx-color--blue);
      width: 100%;
      min-height: 40px;
      padding: var(--dx-space-size--xs) var(--dx-space-size--md);
      border: 1px solid transparent;
      border-radius: 3px;
      cursor: pointer;

      color: white;
      font-size: var(--dx-text-size--md);
      text-align: center;
      text-decoration: none;
      white-space: nowrap;
      vertical-align: middle;
      user-select: none;
      line-height: inherit;

      -webkit-appearance: button;

      &.theme--light {
        background: var(--dx-color--blue-light);
        color: var(--dx-color--blue);
      }

      &:hover:not(:disabled) {
        opacity: 0.8;
      }
      &:active {
        opacity: 1.0;
      }
    }

    button:disabled,
    button[disabled]{
      background-color: #cccccc;
      color: #666666;
    }
  }

  .loading * {
    pointer-events: none!important;
    cursor: wait !important;
    opacity: 0.8 !important;
  }
</style>
